export default "__VITE_ASSET__Cmrilq39__"